import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './fonts';
import { LegacyApp } from './legacy/LegacyApp';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LegacyApp />
  </StrictMode>,
);
